module.exports = __webpack_public_path__ + "img/gBalm1.abe8bbd1.jpg";